import React from 'react';
import { getRank } from '../lib/claude';

const s = {
  card: {
    background: 'var(--card)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius)',
    padding: '1.25rem',
    marginBottom: '1rem'
  },
  label: {
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
    color: 'var(--text-muted)',
    display: 'block',
    marginBottom: '8px'
  },
  btnPrimary: {
    width: '100%',
    padding: '13px',
    background: 'var(--purple)',
    color: 'white',
    border: 'none',
    borderRadius: 'var(--radius-sm)',
    fontSize: '14px',
    fontWeight: 700,
    fontFamily: 'var(--font-display)',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    marginTop: '12px',
    transition: 'all 0.15s'
  },
  btnOutline: {
    width: '100%',
    padding: '12px',
    background: 'transparent',
    color: 'var(--purple)',
    border: '1px solid var(--purple)',
    borderRadius: 'var(--radius-sm)',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    marginTop: '8px'
  }
};

export function Card({ children, style }) {
  return <div style={{ ...s.card, ...style }}>{children}</div>;
}

export function Label({ children }) {
  return <label style={s.label}>{children}</label>;
}

export function BtnPrimary({ children, onClick, disabled, style }) {
  return (
    <button
      style={{ ...s.btnPrimary, ...(disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}), ...style }}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export function BtnOutline({ children, onClick, style }) {
  return <button style={{ ...s.btnOutline, ...style }} onClick={onClick}>{children}</button>;
}

export function RankBadge({ elo }) {
  const rank = getRank(elo);
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '4px',
      padding: '3px 10px', borderRadius: '20px',
      background: rank.color + '22', color: rank.color,
      fontSize: '12px', fontWeight: 500
    }}>
      {rank.emoji} {rank.name}
    </span>
  );
}

export function Avatar({ emoji, size = 56, color = 'var(--purple)', bg }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: bg || color + '22',
      border: `2px solid ${color}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.45, flexShrink: 0
    }}>
      {emoji}
    </div>
  );
}

export function StatBar({ value, max, color = 'var(--purple)' }) {
  const pct = Math.min(100, Math.round((value / max) * 100));
  return (
    <div style={{ height: 6, background: 'rgba(255,255,255,0.08)', borderRadius: 3, overflow: 'hidden' }}>
      <div style={{ height: '100%', width: pct + '%', background: color, borderRadius: 3, transition: 'width 0.6s ease' }} />
    </div>
  );
}

export function Dot({ color }) {
  return (
    <span style={{
      display: 'inline-block', width: 8, height: 8, borderRadius: '50%',
      background: color, animation: 'pulse 1.5s infinite'
    }} />
  );
}

export function SectionTitle({ children }) {
  return (
    <div style={{
      fontFamily: 'var(--font-display)', fontSize: '13px', fontWeight: 700,
      letterSpacing: '1px', textTransform: 'uppercase',
      color: 'var(--text-muted)', marginBottom: '12px'
    }}>
      {children}
    </div>
  );
}
